import type { CommonsStats } from '../lib/types';

const bucketOrder = ['Long-horizon gardener', 'Steady negotiator', 'Present-weather rider', 'Spark chaser'];

export function CommonsPanel({ stats }: { stats: CommonsStats | null }) {
  const total = stats?.savedCurves ?? 0;
  const buckets = bucketOrder.map((bucket) => stats?.buckets.find((b) => b.bucket === bucket) ?? { bucket, n: 0, meanAuc: 0, meanK: 0, meanPresentBias: 0, meanConsistency: 0 });

  return (
    <section className="panel commons-panel" aria-labelledby="commons-title">
      <div className="panel-header">
        <div>
          <p className="eyebrow">the commons</p>
          <h2 id="commons-title">Aggregate patience map</h2>
        </div>
        <span className="stat-pill">{total.toLocaleString()} curves</span>
      </div>
      <p className="arena-copy">
        Individual curves stay pseudonymous. The public surface is the shape of the crowd: mean values, bucket counts, and delay bins.
      </p>
      <div className="bucket-list">
        {buckets.map((bucket) => {
          const pct = total ? Math.round((bucket.n / total) * 100) : 0;
          return (
            <div className="bucket-row" key={bucket.bucket}>
              <div>
                <strong>{bucket.bucket}</strong>
                <span>{bucket.n} saved</span>
              </div>
              <div className="bucket-bar" aria-label={`${bucket.bucket}: ${pct}%`}>
                <span style={{ width: `${pct}%` }} />
              </div>
              <span className="bucket-pct">{pct}%</span>
            </div>
          );
        })}
      </div>
      {stats?.meanAuc != null ? (
        <p className="microcopy">
          Commons mean: patience {Math.round(stats.meanAuc * 100)}/100 · coherence {Math.round((stats.meanConsistency ?? 0) * 100)}% · now-gravity {Math.round((stats.meanPresentBias ?? 0) * 100)}%.
        </p>
      ) : (
        <p className="microcopy">No commons curves yet. First light gets the map started.</p>
      )}
    </section>
  );
}
